import Navbar from "../components/common/Navbar";
import SignUpForm from "../components/signup/SignUpForm";

const SignUp = () => {
  return (
    <>
      <Navbar />
      <SignUpForm />
    </>
  );
};

export default SignUp;
